module.exports = __webpack_public_path__ + "img/marie-jade.f03a4a19.webp";